import { render, staticRenderFns } from "./tableDivisiMagang.vue?vue&type=template&id=a233eb78&scoped=true"
import script from "./tableDivisiMagang.vue?vue&type=script&lang=js"
export * from "./tableDivisiMagang.vue?vue&type=script&lang=js"
import style0 from "./tableDivisiMagang.vue?vue&type=style&index=0&id=a233eb78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a233eb78",
  null
  
)

export default component.exports